import React from 'react';
import { IconButton, Tooltip, Box } from '@mui/material';
import {Facebook, Instagram, Share, X} from '@mui/icons-material';

// Replace with your actual URL
const calculatorURL = encodeURIComponent('https://www.rifcalc.com');

export default function SocialShare() {
    // Share links for Facebook and X
    const facebookShareLink = `https://www.facebook.com/sharer/sharer.php?u=${calculatorURL}`;
    const xShareLink = `https://x.com/intent/tweet?url=${calculatorURL}&text=What%27s%20your%20RIF%20severance%20payout.&hashtags=RIF,Severance,Calculator`;

    // Function to copy the link (for Instagram bio or DMs)
    const copyLinkToClipboard = () => {
        navigator.clipboard.writeText(`https://www.rifcalc.com`);
        alert('Link copied to clipboard!');
    };

    return (
        <Box sx={{ textAlign: 'center', mt: 2 }}>
            <Tooltip title="Share on Facebook">
                <IconButton href={facebookShareLink} target="_blank" rel="noopener noreferrer">
                    <Facebook sx={{ color: '#3b5998' }} />
                </IconButton>
            </Tooltip>

            <Tooltip title="Share on X">
                <IconButton href={xShareLink} target="_blank" rel="noopener noreferrer">
                    <X sx={{ color: '#1DA1F2' }} />
                </IconButton>
            </Tooltip>

            <Tooltip title="Share on Instagram (Copy Link)">
                <IconButton onClick={copyLinkToClipboard}>
                    <Instagram sx={{ color: '#E4405F' }} />
                </IconButton>
            </Tooltip>

            <Tooltip title="Copy Link">
                <IconButton onClick={copyLinkToClipboard}>
                    <Share />
                </IconButton>
            </Tooltip>
        </Box>
    );
}
